import React from 'react'
import AuthDeptMenuContainer from '../../containers/authmenumng/AuthDeptMenuContainer'

const AuthMenuViewPage = () => {
  return (
    <AuthDeptMenuContainer/>
  )
}

export default AuthMenuViewPage